module.exports = __webpack_public_path__ + "static/media/Street_cleaner.c1f206b4.mp3";